module.exports = __webpack_public_path__ + "static/media/12.72015e1b.png";